import type { CommentId } from '@atlassian/jira-issue-view-common-types/src/comment-type.tsx';

export const NEW_COMMENT_ID: CommentId = 'NEW_OPTIMISTIC_COMMENT';
export const NEW_REPLY_COMMENT_ID_PREFIX: CommentId = 'NEW_OPTIMISTIC_COMMENT_REPLY';
